/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Divider,
  HStack,
  Heading,
  Spinner,
  Stack,
  Text,
  Collapse,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { SearchContext } from '../context';
import { SearchPeopleFilters } from './filters';
import { SearchPeopleListing } from './listing';
import { isMobile } from 'react-device-detect';
import { useDisclosure } from '@mybridge/ui';
import { IconButton } from '@chakra-ui/react';
import { Filters } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const SearchPeople = forwardRef(({ ...props }, ref) => {
  const {
    peopleFetchNextPage,
    peopleHasNextPage,
    peopleTotalCount,
    peopleSearchIsFetching,
    query,
  } = useContext(SearchContext);
  const { t } = useTranslator();
  const filterDisc = useDisclosure();
  return (
    <Stack>
      {isMobile ? (
        <Collapse style={{overflow:"inherit"}} overflow="inherit" in={filterDisc?.isOpen} animateOpacity>
          <SearchPeopleFilters />
          <Divider my={2} />
        </Collapse>
      ) : (
        ''
      )}
      <Stack spacing={0}>
        <HStack
          w="100%"
          justifyContent="space-between"
          alignItems="center"
          gap={0}
        >
          <Heading as="h1" pl={2} fontSize="20px" color="brandPrimary.500" fontWeight="400">
            {t('searchPage.people') || "People"}
          </Heading>
          {isMobile && (
            <IconButton
              icon={<Filters />}
              onClick={() => filterDisc.onToggle()}
              variant="transparent"
            />
          )}
        </HStack>
        {query?.query?.length && peopleTotalCount ? (
          <Text m={2} size="sm">{peopleTotalCount} {t('pageJobs.results') || "results"}</Text>
        ) : (
          ''
        )}
      </Stack>
      <SearchPeopleListing />
    </Stack>
  );
});
